import React from "react"
import PhysicalActivitiesStyle from "./PhysicalActivitiesStyle.module.css"
import InputRange from "react-input-range"
import "react-input-range/lib/css/index.css"
import translate, { keys } from "../../../../../translation/translator"

const PhysicalActivities = ({ handleChangeSlider, sliderValue, locale }) => {
  return (
    <div className={PhysicalActivitiesStyle.holder}>
      <p className={PhysicalActivitiesStyle.title}>
        7.{" "}
        {translate(keys.WHICH_MATCHES_YOUR_LEVEL_OF_PHYSICAL_ACTIVITY, locale)}
      </p>
      <div className="calorie-calculator-slider-holder">
        <InputRange
          step={1}
          maxValue={2}
          minValue={0}
          value={sliderValue}
          onChange={sliderValue => handleChangeSlider(sliderValue)}
        />
      </div>
      {sliderValue === 1 ? (
        <p className={PhysicalActivitiesStyle.text}>
          <span>{translate(keys.SLIDER_VALUE_1, locale)}</span>
          <br /> {translate(keys.SLIDER_VALUE_1_TEXT, locale)}
        </p>
      ) : sliderValue === 2 ? (
        <p className={PhysicalActivitiesStyle.text}>
          {" "}
          <span>{translate(keys.SLIDER_VALUE_2, locale)}</span>
          <br /> {translate(keys.SLIDER_VALUE_2_TEXT, locale)}
        </p>
      ) : sliderValue === 0 ? (
        <p className={PhysicalActivitiesStyle.text}>
          {" "}
          <span>{translate(keys.SLIDER_VALUE_0, locale)}</span>
          <br /> {translate(keys.SLIDER_VALUE_0_TEXT, locale)}
        </p>
      ) : null}
    </div>
  )
}

export default PhysicalActivities
